import { Evidence, LinkQueryResult } from '../traceInspector.types';
import fossilizingImg from '@/assets/fossilizing.svg';
import { ExternalLink } from 'lucide-react';
import { parse } from '@stratumn/canonicaljson';
import { EVIDENCE_BATCH_FOSSILIZER } from '@/constant/chainscript';

type Props = {
  link: LinkQueryResult;
};

export const SegmentEvidence = ({ link }: Props) => {
  const evidences = link.evidences;

  if (!evidences.totalCount) {
    return (
      <div className="flex flex-col items-center">
        <img src={fossilizingImg} alt="" className="my-5 w-7/10" />
        <div className="text-xs font-semibold">
          The blockchain info for this action is not yet ready. Actions are
          normally recorded every day.
        </div>
      </div>
    );
  }

  const renderBatchEvidence = (evidence: Evidence) => {
    const proof = parse(Buffer.from(evidence.proof.proof, 'base64').toString());
    return renderProof(proof, evidence.provider);
  };

  const renderProof = (proof: { txid: string }, provider: string) => {
    const linkHash = link.linkHash;

    const network = provider.includes('test') ? 'btc-testnet' : 'btc';
    const explorerURL = `https://live.blockcypher.com/${network}/tx/${proof.txid}`;

    return (
      <div
        className="border-border text-muted-foreground border-b text-xs break-words"
        key={proof.txid}
      >
        <dl className="last-of-type:mb-4">
          <dt className="inline font-bold">Event hash:</dt>
          <dd className="inline pl-1">{linkHash}</dd>
        </dl>
        <dl className="last-of-type:mb-4">
          <dt className="inline font-bold">Blockchain:</dt>
          <dd className="inline pl-1">
            This event hash is independently verifiable on the Bitcoin public
            blockchain. Check on{' '}
            <a
              href={explorerURL}
              className="text-primary-deep hover:text-primary-deep/80 inline-flex items-center gap-1 no-underline hover:underline"
            >
              blockcypher.com
              <ExternalLink size={14} />
            </a>
          </dd>
        </dl>
        <dl className="last-of-type:mb-4">
          <dt className="inline font-bold">Transfer ID:</dt>
          <dd className="inline pl-1">{proof.txid}</dd>
        </dl>
      </div>
    );
  };

  return (
    <>
      {evidences.nodes.map(evidence => {
        switch (evidence.backend) {
          case EVIDENCE_BATCH_FOSSILIZER:
            return renderBatchEvidence(evidence);
          default:
            return null;
        }
      })}
    </>
  );
};
